import {useSelector} from 'react-redux';
import {RootState} from '../reducers/rootReducer';
import utils from '../helpers/utils';

const useWhiteLabelClient = () => {
  return useSelector((store: RootState) => utils.safeGet(store, 'auth.whiteLabelClient', ''));
};

export default useWhiteLabelClient;
